export class BasicInformations {
    constructor(public data: {
        contractorType?: String,
        contractorFirstname?: String,
        contractorLastname?: String,
        contractorJMBG?: String,
        contractorEmail?: String,
        contractorPIB?: String,
        contractorID?: String,
        contractorResponsibleName?: String, 
        contractorAddress?: String,
        contractorPostalCode?: String,
        contractorSettlement?: String,
        contractorPhonenumber?: string,
        contractorAddressOfDelivery?: String,
        contractorPostalCodeOfDelivery?: String,
        contractorSettlementOfDelivery?: String,
        contractorCopy?: Boolean,
        insuredFirstname?: String,
        insuredLastname?: String,
        insuredEmail?: String,
        insuredAddress?: String,
        insuredDOB?: String,
        insuredPostalCode?: String,
        insuredSettlement?: String,
        insuredJMBG?: String,
        insuredMobile?: string,
        insuredJob?: String
    }) { }
}